var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M89.5,30.8V18.4c0-5.2-4.2-9.4-9.4-9.4H51c-5.2,0-9.4,4.2-9.4,9.4v12.5c-4.5,0.6-8.1,4.5-8.1,9.3v63.3   c0,4.5,3.2,8.3,7.5,9.2v1.6c0,2.5,2,4.5,4.5,4.5c2.5,0,4.5-2,4.5-4.5v-1.4h31v1.4c0,2.5,2,4.5,4.5,4.5s4.5-2,4.5-4.5v-1.6   c4.3-0.9,7.5-4.7,7.5-9.2V40.1C97.5,35.4,94,31.5,89.5,30.8z M93.8,103.4c0,2.6-1.8,4.8-4.2,5.4V34.7c2.4,0.6,4.2,2.8,4.2,5.4   V103.4z M85.5,114.9c-0.4,0-0.7-0.3-0.7-0.7v-1.4h1.5v1.4C86.3,114.5,85.9,114.9,85.5,114.9z M45.6,114.9c-0.4,0-0.7-0.3-0.7-0.7   v-1.4h1.5v1.4C46.3,114.5,46,114.9,45.6,114.9z M37.3,103.4V40.1c0-2.6,1.8-4.8,4.2-5.4v74.2C39.1,108.2,37.3,106,37.3,103.4z    M82.9,34.5h2.9V109h-2.9V34.5z M48.1,109h-2.9V34.5h2.9V109z M51.9,109V34.5h27.3V109H51.9z M51,12.7h29.1c3.1,0,5.6,2.5,5.6,5.6   v12.4h-4.6H50h-4.6V18.4C45.4,15.3,47.9,12.7,51,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1,52.6H76c1,0,1.9-0.8,1.9-1.9v-9.8c0-1-0.8-1.9-1.9-1.9H55.1c-1,0-1.9,0.8-1.9,1.9v9.8C53.2,51.7,54.1,52.6,55.1,52.6   z M57,42.7h17.1v6.1H57V42.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassenger);
export default __webpack_public_path__ + "static/media/passenger.6107d1f138d375bed19923f7af0f193d.svg";
export { ForwardRef as ReactComponent };